/**
 * PillarComplianceBars.tsx
 *
 * Displays compliance bars for all FAIR pillars (F/A/I/R)
 * Wrapper component for individual ComplianceBar components
 */

import React from 'react';
import { ComplianceBar, PillarCompliance } from './ComplianceBar';

interface PillarComplianceBarsProps {
  compliance: PillarCompliance[];
}

export function PillarComplianceBars({ compliance }: PillarComplianceBarsProps) {
  // Sort by pillar order: F, A, I, R
  const sortedCompliance = [...compliance].sort((a, b) => {
    const order = { F: 0, A: 1, I: 2, R: 3 };
    return order[a.pillar] - order[b.pillar];
  });

  return (
    <div className="pillar-compliance-bars" style={{
      padding: '20px',
      backgroundColor: '#f9fafb',
      borderRadius: '8px',
      marginBottom: '20px'
    }}>
      <h3 style={{ marginBottom: '16px', fontSize: '18px', fontWeight: '600' }}>
        FAIR Compliance
      </h3>

      {sortedCompliance.map(c => (
        <ComplianceBar key={c.pillar} compliance={c} />
      ))}
    </div>
  );
}
